module.exports = __webpack_public_path__ + "img/tanzim.a68a568.png";